import { EkStueckliste } from "@/components/ek-stueckliste/ek-stueckliste";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/ek-stueckliste/")({
  component: EkStueckliste,
});
